import React from 'react';
import { formatBrlInput, parseBrlInputToCents } from './invoiceMoney.mjs';
import InvoiceInfo from './InvoiceInfo';
import './InvoiceTransportationOptions.css';

export default function InvoiceMealAllowanceOptions({ options, onChange, disabled = false }) {
  if (!options.chargeMealAllowance) return null;
  const source = ['general', 'automatic'].includes(options.mealAllowanceSource) ? options.mealAllowanceSource : 'registered';
  return <div className="invoice-transportation-options" style={{ gridColumn: '1 / -1' }}>
    <label><span>Origem do VA</span><select value={source} disabled={disabled} onChange={event => onChange('mealAllowanceSource', event.target.value)}>
      <option value="registered">VA cadastrado</option><option value="general">VA geral</option><option value="automatic">Automático</option>
    </select></label>
    {source === 'automatic' && <p className="ya-report-note">Valor diário de VA do cadastro × dias elegíveis da referência, sem férias e feriados. Confira o Relatório de VA.</p>}
    {source === 'general' && <label><span>VA geral por jovem<InvoiceInfo label="VA geral" description="Aplica o mesmo valor somente aos jovens selecionados com vale-alimentação habilitado no cadastro, substituindo o valor individual nesta emissão." /></span>
      <input aria-label="VA geral por jovem" disabled={disabled} inputMode="numeric" value={(Number(options.generalMealAllowanceCents || 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
        onChange={event => onChange('generalMealAllowanceCents', parseBrlInputToCents(formatBrlInput(event.target.value)))} />
    </label>}
  </div>;
}
